import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useWorkspace } from '@/api/workspace'
import { MachineForm } from '@/components/machines/machine-form'

// Machine create (UI-SCREENS F-02, #127). Owner only; the API refuses Staff too.
export const Route = createFileRoute('/w/$slug/machines/new')({
  component: NewMachine,
  staticData: { breadcrumb: 'machines.form.newTitle' },
})

function NewMachine() {
  const { t } = useTranslation()
  const { slug } = Route.useParams()
  const workspace = useWorkspace(slug)

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/machines" params={{ slug }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('machines.form.newTitle')}</h1>
      <MachineForm slug={slug} />
    </section>
  )
}
